import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import language from '../../../assets/languages/language';
import { examNameAccordingToDB } from '../../../common/constant';
import Loader from '../../../common/loader';
import { showFailure } from '../../../common/toast';
import ModalComponent from '../../Common/Modal';
import PDFModelComponent from '../../Common/PDFModel';
import StatusChangeModel from '../../Common/StatusChangeModel';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import FD from '../../RestAPI/fetchData';
import AppRoutes from '../../config/AppRoutes';
import App_data from '../../config/App_data';
import alertMessage from '../../config/alertMessage';
import Heading from './Layout/Heading';
import Table from './Layout/Table';
import { renderHTMLContent } from '../../../common/function';
import userStore from "../../../store/userStore";

/* eslint-disable */

export class EssayCases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cases: [],
      displayLoader: true,
      subscriptionstatus: 'free',
      premiumAlertStatus: false,
      changeStatusTitle: `${language.LC().Mark_this_Question_as_Completed}`,
      change_status: false,
      case_number: 0,
      change_case_no: 0,
      case_chapterId: 0,
      chapterid: this.props.params ? this.props.params.chapterID : 1,
      showFreePremium: true,
      userType: '',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      selectedExam: 'cfa_3',
      selectedmenu: 'cfa_3',
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      errorMessage: 'No data found!',
      userStats: [],
      // 1 -> for View
      // 2 -> for Status
      showComponent: [3],
      showLoaderOnModel: true,
      pdfLoading: true,
      pdfLoadingAnswer: true,
    };
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };

  pdfAlertModel() {
    this.setState({
      pdfAlert: !this.state.pdfAlert,
    });
  }
  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const { params } = this.props;
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      chapterId: params ? params.chapterID : 1,
    };
    this.getCases(data);

    this.getUserDetails(data);
  }

  getpdf = async e => {
    console.log('inside functionnn');
    const { pdfLoading, pdfLoadingAnswer } = this.state;
    if (pdfLoading === false) {
      alert('Download is in progress....');
      return;
    }
    if (pdfLoadingAnswer === false) {
      alert('Please wait one process is in queue.');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      // console.log("resp", resp);
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log('resp_exam', resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var_PDF = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    questionType: 'essay_question',
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              // console.log('resp_exam', resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                // console.log('isInArray_var_PDF before', isInArray_var_PDF);
                isInArray_var_PDF = await Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                // console.log('isInArray_var_PDF after', isInArray_var_PDF);
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    questionType: 'essay_question',
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_3question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
              }
            },
          );
        }
      }
    });
  };

  getUserDetails = async data => {
    // subscription check code started
    // const getUserDetails = await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data);
    const getUserDetails = await userStore.getUserProfile(true);
    const response = await this.setUserDetails(getUserDetails, data);
    if (response) {
      this.getExamByUser({ ...data, ...response });
    }
  };

  getExamByUser = async data => {
    const getExamByUser = await FD.callAPI(
      App_data.backend_api + '/checkout_v1/getExamsbyUser',
      data,
    );
    if (getExamByUser.success) {
      const { examData } = getExamByUser;
      const { selectedExam, cfaUnlimitedPackage, cfaUnlimitedActiveExam } = this.state;
      var exam_data = examData;
      var selectedmen = selectedExam;
      var isInArray_var = false;

      isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
        selectedmen,
        exam_data,
        cfaUnlimitedPackage,
        cfaUnlimitedActiveExam,
      );
      if (isInArray_var) {
        this.setState({
          showFreePremium: false,
          userType: 'paid',
        });
      } else {
        this.setState({
          showFreePremium: true,
          userType: 'free',
        });
      }
    } else {
    }
  };

  setUserDetails = async getUserDetails => {
    const {
      profileInfo: { cfaUnlimitedPackage, cfaUnlimitedActiveExam, exam_selected },
    } = getUserDetails;
    if (exam_selected === '' && cfaUnlimitedPackage === '' && cfaUnlimitedActiveExam === '') {
      this.setState({ showFreePremium: true, userType: 'free' });
    } else {
      this.setState({
        cfaUnlimitedPackage: cfaUnlimitedPackage,
        cfaUnlimitedActiveExam: cfaUnlimitedActiveExam,
      });
      const data_arr = exam_selected ? JSON.parse(exam_selected) : null;
      return {
        examid: data_arr,
      };
    }
    return null;
  };

  getCases = async data => {
    const getCases = await FD.callAPI(
      App_data.backend_api + '/cfa3EssayQuestions/getCasesByChaptersId',
      data,
    );
    const { success } = getCases;
    if (success) {
      this.setState({
        ValidToken: true,
        cases: getCases && getCases.cases,
      });
    } else {
      this.setState({
        ValidToken: false,
        errorMessage: getCases && getCases.message,
      });
    }
    this.setState({
      displayLoader: false,
    });
  };

  //Function to redirect page on specific questions
  _beginChapter = (cases, index) => {
    localStorage.removeItem('attemptedQuestions');

    const { subscriptionstatus, showFreePremium } = this.state;
    const {
      params: { chapterName, chapterID },
    } = this.props;
    if (subscriptionstatus === 'free' && showFreePremium === true && cases.free === false) {
      this.togglePremiumAlert();
    } else {
      this.context.router.push({
        pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', cases.id)
          .replace(':chapterName', chapterName)
          .replace(':chapterID', chapterID)
          .replace(':questionIndex', 0)
          .replace(':caseIndex', index),
      });
    }
  };

  togglePremiumAlert() {
    this.setState({
      premiumAlertStatus: !this.state.premiumAlertStatus,
    });
  }

  toggleAlertChangeStatus = (item, index) => {
    this.setState({
      change_status: !this.state.change_status,
      change_case_no: item.id,
      case_chapterId: item.chapter_id,
      showComponent: [2],
      showLoaderOnModel: false,
    });
    item.cfa3_essay_question_cases_statuses.length &&
      item.cfa3_essay_question_cases_statuses[0].status === 1
      ? this.setState({
        change_completion_status: item.cfa3_essay_question_cases_statuses[0].status,
        markAsCompleted: true,
        markAsNotCompleted: false,
      })
      : this.setState({
        change_completion_status: 0,
        markAsCompleted: false,
        markAsNotCompleted: true,
      });
  };
  markCompleted = () => {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  };
  markNotCompleted = () => {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  };
  changeCompletionStatus = async e => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    var data;
    if (this.state.markAsCompleted) {
      data = {
        chapterNo: this.state.case_chapterId,
        caseNo: this.state.change_case_no,
        status: 1,
        idname: storage_session['idname'],
        token: storage_session['token'],
      };
    } else {
      data = {
        chapterNo: this.state.case_chapterId,
        caseNo: this.state.change_case_no,
        status: 0,
        idname: storage_session['idname'],
        token: storage_session['token'],
      };
    }
    await FD.callAPI(App_data.backend_api + '/cfa3EssayQuestions/upsertUserStats', data).then(
      updateStatus => {
        this.setState({ change_status: false });
        const { params } = this.props;

        const data = {
          idname: storage_session['idname'],
          token: storage_session['token'],
          chapterId: params ? params.chapterID : 1,
        };
        this.getCases(data);
      },
    );
  };
  changeModelStatus = () => {
    this.setState({
      change_status: false,
    });
  };

  getSummary = async item => {
    this.setState({
      showLoaderOnModel: true,
    });
    const { token, idname } = this.state;
    const data = {
      token,
      idname,
      caseId: item.id,
    };
    this.setState({
      change_status: true,
      changeStatusTitle: 'View Summary',
    });
    const result = await FD.callAPI(`${App_data.backend_api}/cfa3EssayQuestions/getSummary`, data);
    if (result.success) {
      const { userStats } = result;
      this.setState({
        userStats,
        showComponent: [1],
        showLoaderOnModel: false,
      });
    } else {
      this.setState({
        change_status: true,
      });
      showFailure('Something went wrong');
    }
  };
  getpdfAnswer = async e => {
    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var_PDF = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    questionType: 'essay_question',
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;

                isInArray_var_PDF = await Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    questionType: 'essay_question',
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_3question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };
  render() {
    const {
      props: { params },
      state: {
        displayLoader,
        cases,
        subscriptionstatus,
        premiumAlertStatus,
        errorMessage,
        userStats,
        showFreePremium,
        showComponent,
        showLoaderOnModel,
      },
    } = this;
    let data = '';
    if (cases.length) {
      data = cases.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}.</td>
          {renderHTMLContent(item.case_name, "td")}
          <td className='d-flex'>
            <span className='tooltip_wrap margin_right_20 '>
              <img
                src={App_data.frontend_url + '/img/question_bank/eye_icon.svg'}
                className='pointer_class'
                alt=''
                width='23'
                onClick={() => this.getSummary(item)}
                id={item.id}
                title=''
              />
              <div className='tootip_box'>View Summary</div>
            </span>
            <span className='tooltip_wrap'>
              <img
                src={`${App_data.frontend_url}${subscriptionstatus === 'free' && showFreePremium === true && item.free === false
                  ? '/img/subsciption-dark.svg'
                  : '/img/question_bank/open_book_icon.svg'
                  }`}
                className='pointer_class'
                alt=''
                width='21'
                id={item.id}
                onClick={() => this._beginChapter(item, index)}
                title=''
              />
              <div className='tootip_box'>
                {' '}
                {subscriptionstatus === 'free' && showFreePremium === true && item.free === false
                  ? language.LC().UPGRADE_ACCOUNT
                  : language.LC().BEGIN_CASES}
              </div>
            </span>
          </td>
          {subscriptionstatus === 'free' &&
            showFreePremium === true &&
            item.free === false ? null : (
            <td>
              <div className='complete-or-not'>
                <span className='complete-or-not-text'>
                  {item.cfa3_essay_question_cases_statuses.length &&
                    item.cfa3_essay_question_cases_statuses[0].status === 1
                    ? language.LC().COMPLETED
                    : language.LC().NOT_COMPLETED}
                </span>
                <span className='tooltip_wrap left-tool-tip'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/edit-icon.svg'}
                    className='pointer_class'
                    alt=''
                    width='15'
                    id={item.id}
                    onClick={this.toggleAlertChangeStatus.bind(this, item, index)}
                    title=''
                  />
                  <div className='tootip_box'> {language.LC().CHANGE_STATUS} </div>
                </span>
              </div>
            </td>
          )}
        </tr>
      ));
    } else {
      data = (
        <tr>
          <th colSpan='100%' className='font-bold text-center' style={{ fontWeight: 'bold' }}>
            {errorMessage}
          </th>
        </tr>
      );
    }

    return (
      <div className='animated fadeIn'>
        {/* ========= Heading ===================== */}
        <Heading headerText={params ? params.chapterName : 'Essay Question Cases'}>
          <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoading ? language.LC().Download_Q_Cases : '  please wait...'}
              </a>
            </div>
            <div onClick={this.getpdfAnswer} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right max-width-200'>
                {this.state.pdfLoadingAnswer ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoadingAnswer ? language.LC().Download_QA_Cases : '  please wait...'}
              </a>
            </div>
            <button
              className='btn btn-primary pointer_class'
              onClick={() => {
                this.context.router.push({
                  pathname: AppRoutes.CFA3_ESSAY_QUESTION_CHAPTERS,
                });
              }}
            >
              Change Topic
            </button>
          </div>{' '}
        </Heading>
        <Row>
          <Col md='12'>
            <div className='card height_70vh'>
              <div className='card-header'>Case Studies - {params ? params.chapterName : ''}</div>
              {/* =============== TABLE ================ */}
              {displayLoader ? (
                <Loader />
              ) : (
                <Table>
                  <thead>
                    <tr className='border_top_0'>
                      <th width='90'>#</th>
                      <th> {language.LC().CASE_NAME} </th>
                      <th className='action-heading'>{language.LC().ACTION}</th>
                      <th className='status-heading'>{language.LC().STATUS}</th>
                    </tr>
                  </thead>
                  <tbody>{data}</tbody>
                </Table>
              )}
            </div>
          </Col>
        </Row>

        <StatusChangeModel
          change_status={this.state.change_status}
          className={''}
          changeModelStatus={this.changeModelStatus}
          changeStatusTitle={this.state.changeStatusTitle}
          markAsCompleted={this.state.markAsCompleted}
          markNotCompleted={this.markNotCompleted}
          markAsNotCompleted={this.state.markAsNotCompleted}
          markCompleted={this.state.markCompleted}
          markCompletedFun={this.markCompleted}
          changeCompletionStatus={this.changeCompletionStatus}
          summaryDetails={userStats}
          showComponent={showComponent}
          showLoaderOnModel={showLoaderOnModel}
        />
        <ModalComponent
          goPremium={() =>
            this.context.router.push({
              pathname: '/Subscribe/',
            })
          }
          toggleAlert={this.togglePremiumAlert.bind(this)}
          alert_status={premiumAlertStatus}
          MessageContent={alertMessage.messageContent_cfa_3}
          exam={examNameAccordingToDB.CFA_LEVEL_3}
        />

        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={language.LC().PDFContentMessage}
        />
      </div>
    );
  }
}

export default EssayCases;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/EssayCases.jsx